import React, { ReactNode } from "react";
import { Typography } from "@mui/material";

// Heads a group of controls that has no input label of its own (a list, a
// few switches), in the input labels' style.
export const SettingsSectionTitle = ({ children }: { children: ReactNode }) => (
  <Typography variant="body3" color="textPrimary" component="div" px={4} pb={1}>
    {children}
  </Typography>
);
